import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { OrganizationManager } from "../organization-manager";
import { VolunteerOrganization } from "../volunteer-organization";
import { VolunteerOrganizationLeadEntityConfig } from "./config";
import { VolunteerOrganizationLeadFilters } from "./filters";
import { VolunteerOrganizationLeadMethods } from "./methods";

@HyperEntity("volunteer-organization-lead", VolunteerOrganizationLeadEntityConfig)
export class VolunteerOrganizationLead extends extender(
  VolunteerOrganizationLeadFilters,
  VolunteerOrganizationLeadMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ caption: "שם הארגון" })
  name = "";

  @Fields.string({
    dbName: "handling_manager_id",
    caption: "מנהל מלווה",
  })
  handlingManagerId = "";

  @Relations.toOne<VolunteerOrganizationLead, OrganizationManager>(
    () => OrganizationManager,
    "handlingManagerId",
  )
  handlingManager?: OrganizationManager;

  @Fields.literal(() => ["CALL", "WHATSAPP", "EMAIL"] as const, {
    dbName: "contact_channel",
    caption: "דרך יצירת קשר",
  })
  contactChannel: "CALL" | "WHATSAPP" | "EMAIL" = "CALL";

  @Fields.string({
    dbName: "phone_number",
    allowNull: true,
    caption: "טלפון",
  })
  phoneNumber?: string | null;

  @Fields.string({
    dbName: "notes",
    allowNull: true,
    caption: "הערות",
  })
  notes?: string | null;

  @Fields.string({
    dbName: "volunteer_organization_id",
    allowNull: true,
    caption: "ארגון מתנדבים",
  })
  volunteerOrganizationId?: string | null;

  @Relations.toOne<VolunteerOrganizationLead, VolunteerOrganization>(
    () => VolunteerOrganization,
    "volunteerOrganizationId",
  )
  volunteerOrganization?: VolunteerOrganization;

  @Fields.date({
    dbName: "converted_at",
    allowNull: true,
    caption: "תאריך המרה",
  })
  convertedAt?: Date | null;

  @Fields.createdAt({ dbName: "created_at", caption: "תאריך יצירה" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at", caption: "תאריך עדכון" })
  updatedAt = new Date();
}
